import React from "react";
import Lottie from "react-lottie";
import cx from "clsx";
import { Transition } from "react-transition-group";

import globalStyles from "@/styles/global.module.scss";
import styles from "./loadingSpinner.module.scss";

const LOTTIE_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: require("@/assets/lottie/loading-spinner.json"),
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

const LoadingSpinner = props => {
  const { visible, isStopped, isHovered, className } = props;

  return (
    <Transition enter exit in={visible} timeout={0}>
      {state => (
        <div
          className={cx(
            styles.container,
            globalStyles.opacityAnimation,
            globalStyles[state],
            className
          )}
        >
          <Lottie
            options={LOTTIE_OPTIONS}
            width={105}
            height={120}
            isStopped={isStopped || isHovered}
          />
        </div>
      )}
    </Transition>
  );
};

export default LoadingSpinner;
